import { render, staticRenderFns } from "./PreLoader.vue?vue&type=template&id=16ef2b09&scoped=true&"
var script = {}
import style0 from "./PreLoader.vue?vue&type=style&index=0&id=16ef2b09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ef2b09",
  null
  
)

export default component.exports